import { render, staticRenderFns } from "./WalletPassForm.vue?vue&type=template&id=c875ed18&scoped=true"
import script from "./WalletPassForm.vue?vue&type=script&lang=js"
export * from "./WalletPassForm.vue?vue&type=script&lang=js"
import style0 from "./WalletPassForm.vue?vue&type=style&index=0&id=c875ed18&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c875ed18",
  null
  
)

export default component.exports